export default {
  type: 'Flood',
  sections: [
    { id: 'flood1', title: 'What is Flood Insurance?' },
    { id: 'htgbr', title: 'How to Get The Best Rate' },
    { id: 'coverage', title: 'How much coverage do I need?' },
    { id: 'flood2', title: 'Main Price Impacting Factors' }
  ],
  introData: {
    title: 'Understanding Flood Insurance',
    paragraphs: [
      "Flood Insurance is a stand-alone insurance product that specifically protects your home from the peril of rising flood waters. Standard home insurance policies do not cover the peril of flood.",
      "Separate flood insurance policies are required if a homeowner would like to protect their home from the peril of rising flood waters. Flood Insurance is optional in low risk flood zones, a 1 in 500 year risk (Zones B, C and most commonly zone X).",
      "Flood Insurance is required by mortgage lenders for high risk flood zones, a 1 in 100 year risk (Zones A, AE, A1-30, AH, AO, V, VE, and V1-30.)"
    ]
  },
  bestRateTips: [
    "The rule of thumb at all times is to compare quotes between as many companies as you can. Comparing quotes across multiple companies is always the most effective approach to getting the best pricing.",
    "You can often find better rates with the \"private\" market rather than shopping with FEEMA and the NFIP.",
    "Make sure you get the right coverage, too little or too much can cause you to severely over-pay.",
    "Elevation is going to be a large factor when evaluating your property for flood risk, the higher you are, the lower you usually pay.",
    "Bundle your policies and check for discounts- you can check for discounts by using an \"Elevation Certificate.\" Elevation certificates can only help your rate."
  ],
  briefGuide: "One of the main topics of conversation when getting flood insurance is- \"How much coverage should I get?\" The answer can vary for different peoples circumstances but here is a couple data points to keep in consideration.",
  coverageItems: [
    "Building Coverage",
    "Content Coverage",
    "Temporary Living Expenses",
    "Detached Structure Coverage"
  ],
  additionalInfo: {
    overview: "Building coverage will be the main coverage that will be protecting your home. Content coverage will protect your personal belongings.",
    sections: [
      {
        title: "Building Coverage",
        paragraphs: [
          "Building coverage will be the main coverage that will be protecting your home. A great way of remembering what is covered under building coverage would be through a question- \"If you were to move tomorrow, what would you put in the moving van and what would you leave behind?\"",
          "Everything that you would leave behind, would typically be included in your building coverage. This would include- the structural aspects of the building, the equipment that powers the home (water heater, HVAC, electrical, etc.), and any built in features like your kitchen cabinets."
        ]
      },
      {
        title: "Content Coverage",
        paragraphs: [
          "Content Coverage will be the coverage that will be protecting your personal belongings. Like Building Coverage, this can be remembered by using the question- \"If you were to move tomorrow, what would you put in the moving van and what would you leave behind?\"",
          "In this situation, everything that you would be putting in the moving van would fall under Content Coverage.",
          "Content coverage covers for personal belongings, this typically includes- clothing, furniture, electronic equipment and can even provide protection for your washer and dryer unit."
        ]
      },
      {
        title: "Temporary Living Expenses",
        paragraphs: [
          "Temporary living expenses are reserved for providing you some additional money to pay for a place to stay and food to eat during the time that you are unfortunately displaced from your home during a flood peril."
        ]
      },
      {
        title: "Detached Structure Coverage",
        paragraphs: [
          "Detached Structure Coverage is designed to give coverage to any detached structures on the property (other than detached garages, they are covered up to 10% of the building coverage limit. This would include any structures with four walls and a roof."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Flood Insurance",
    description: "When comparing rates and coverages for flood insurance, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Multi-Policy Discount",
        description: "It goes without saying, Insurance Companies like when you purchase more than one policy with them. Consider this when you are getting one policy, they may give a deeper discount by adding another.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Elevation Data",
        description: "One of the most impactful data points when evaluating flood risk is elevation data. This is how elevated your home is in comparison to base flood elevation of the flood zone your property is in.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Flood Zone",
        description: "Flood Zones are a huge impacting factor when calculating flood insurance rates. Low risk flood zones will naturally produce much lower rates than high risk flood zones. Examples of low risk flood zones are- (Zones B,C, and most commonly zone X) Examples of high risk zones are- (Zones A, AE, A1-30, AH, AO,V,VE, and V1-30)",
        imageUrl: "/images/productPageImages/credit.png"
      },
      {
        title: "Coverage",
        description: "Coverage amounts and selected coverages will naturally make a significant impact on your flood insurance rates. FEEMA offers maximum coverage amounts of $250,000 for building coverage and $100,000 for content coverage. Private companies can go as high as $5 million dollars in coverage! The more coverage you get, the higher your cost will be on average.",
        imageUrl: "@/assets/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Home Insurance",
      imageUrl: "@/assets/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Auto Insurance",
      imageUrl: "@/assets/images/product-type-icons/autoInsurance.svg",
      link: "/products/autoinsurance"
    }
  ],
  ctaText: "(Home, Auto, Life, etc.)"
}; 